import {getUserAuth} from '@/http/common'
import { eachAllChild } from '@/utils/index'
import { Message } from 'element-ui'
const user = {
    state: {
        name: '',
        rolesList: [],
        actionList: [],
        info: {},
        historySearchData: {},
        historySearchPage: 1,
    },
    mutations: {
        SET_NAME: (state, { name, welcome }) => {
            state.name = name
            state.welcome = welcome
        },
        SET_ROLES: (state, roles) => {
            state.rolesList = roles
        },
        SET_ACTIONS: (state, actions) => {
            state.actionList = actions
        },
        SET_INFO: (state, info) => {
            state.info = info
        },
        updateHistorySearchData: (state, data) => { 
            state.historySearchData = data
        },
        updateHistorySearchPage: (state, data) => { 
            state.historySearchPage = data
        }
    },

    actions: {
        // 获取用户信息
        GetInfo({ commit,state }) {
            return new Promise((resolve, reject) => {
                getUserAuth().then(response => {
                    if(!response) {
                        Message.error({ message: '此账号未分配权限!' });
                        localStorage.clear()
                        reject(new Error())
                        return
                    }
                    const menuObj = response.datas.content || []
                    let actionList = [],menuList = []

                    eachAllChild(menuObj,(item)=>{
                        let menuModel = item.model
                        if(menuModel.menuType == 1){
                            menuModel.menuCode && menuList.push(menuModel.menuCode)
                        }else{
                            menuModel.menuCode && actionList.push(menuModel.menuCode)
                        }
                    })
                    if (menuList && menuList.length > 0) {
                        commit('SET_ROLES', menuList)
                        commit('SET_ACTIONS', actionList)
                    } else {
                        reject(new Error('getInfo: roles must be a non-null array !'))
                    }
                    resolve(menuList)
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 登出
        Logout({ commit, state }) {
            // return new Promise((resolve) => {
            //     commit('SET_INFO', {})
            //     commit('SET_ROLES', [])
            //     commit('SET_ACTIONS', [])
            //     // resolve(true)
            //     logout().then(() => {
            //         resolve(true)
            //     }).catch(() => {
            //         resolve()
            //     })
            // })
        }

    }
}

export default user